var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-health-6324766 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9994 10.166C13.6039 10.166 14.0939 10.6408 14.0939 11.2265V12.287H15.1885C15.793 12.287 16.283 12.7618 16.283 13.3474C16.283 13.9331 15.793 14.4079 15.1885 14.4079H14.0939V15.4684C14.0939 16.0541 13.6039 16.5289 12.9994 16.5289C12.3949 16.5289 11.905 16.0541 11.905 15.4684V14.4079H10.8104C10.2059 14.4079 9.71582 13.9331 9.71582 13.3474C9.71582 12.7618 10.2059 12.287 10.8104 12.287H11.905V11.2265C11.905 10.6408 12.3949 10.166 12.9994 10.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9981 5.97451C15.4897 4.53819 18.711 4.90128 20.8353 7.06239C23.386 9.65735 23.3892 13.864 20.8391 16.4583C20.8155 16.4823 20.7917 16.5062 20.7678 16.5298C20.7546 16.5439 20.7413 16.5577 20.7277 16.5716L14.5152 22.8919C13.6813 23.74 12.3295 23.74 11.4957 22.8919L5.27541 16.5638C5.26198 16.5501 5.24875 16.5363 5.23573 16.5223C5.21193 16.4988 5.18826 16.4751 5.16473 16.4511C2.61396 13.8562 2.61084 9.64951 5.1609 7.05526C7.28465 4.89474 10.5062 4.53614 12.9981 5.97451ZM19.3256 8.59825C17.7717 7.01746 15.345 6.86536 13.6277 8.14214L12.9976 8.6106L12.3677 8.14194C10.6476 6.86229 8.2214 7.01349 6.67062 8.59112C4.95575 10.3357 4.95606 13.1671 6.67444 14.9153C6.69519 14.9364 6.71608 14.9572 6.73712 14.9778L6.76162 15.0018L6.78456 15.0273L13.0054 21.3559L19.218 15.0356L19.2417 15.0093L19.2664 14.9852C19.2876 14.9646 19.3086 14.9436 19.3294 14.9224C21.0443 13.1778 21.044 10.3464 19.3256 8.59825Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.5b466137a5557ba8c73e63e1cd0c36d0.svg";
export { ForwardRef as ReactComponent };